import ArrowTopRightIcon from '@assets/icons/arrow-corner-right.svg';
import BankIcon from '@assets/icons/bank.svg';
import ChainLinkIcon from '@assets/icons/chain-link.svg';
import i18n from '@/utils/i18n';
import RevertIcon from '@assets/icons/revert.svg';
import WalletIcon from '@assets/icons/wallet.svg';
import { ListOption } from '@/components/list-item';
import { SvgProps } from 'react-native-svg';
import { ThemedSVGProps } from '@/styles';
import { useTheme } from '@/contexts/theme-context';

export type PaymentsActionListOption = ListOption<{
  Icon: React.ComponentType<SvgProps>;
  iconProps?: ThemedSVGProps;
  onPress: () => void | Promise<void>;
}>;

export enum PaymentsAction {
  BANK_DEPOSITS = 'BANK_DEPOSITS',
  PAYMENT_LINKS = 'PAYMENT_LINKS',
  TRANSACTION_HISTORY = 'TRANSACTION_HISTORY',
  VIEW_STATEMENT = 'VIEW_STATEMENT',
  VIEW_WALLET = 'VIEW_WALLET',
}

interface PaymentsScreenMoreActionsOptions {
  onBankDepositsPress?: (() => void) | null;
  onPaymentLinksPress?: (() => void) | null;
  onTransactionHistoryPress?: (() => void) | null;
  onViewStatementPress?: (() => void) | null;
  onWalletPress?: (() => void) | null;
}

export const usePaymentsScreenMoreActions = ({
  onBankDepositsPress,
  onPaymentLinksPress,
  onTransactionHistoryPress,
  onViewStatementPress,
  onWalletPress,
}: PaymentsScreenMoreActionsOptions) => {
  const theme = useTheme();
  const moreActionsList: PaymentsActionListOption[] = [];

  if (onWalletPress) {
    moreActionsList.push({
      metadata: {
        Icon: WalletIcon,
        iconProps: {
          stroke: theme.sk.color.icon.primary,
        },
        onPress: onWalletPress,
      },
      title: i18n.t('wallet'),
      value: PaymentsAction.VIEW_WALLET,
    });
  }

  if (onViewStatementPress) {
    moreActionsList.push({
      metadata: {
        Icon: ArrowTopRightIcon,
        iconProps: {
          fill: theme.sk.color.icon.primary,
        },
        onPress: onViewStatementPress,
      },
      title: i18n.t('view_statement'),
      value: PaymentsAction.VIEW_STATEMENT,
    });
  }

  if (onTransactionHistoryPress) {
    moreActionsList.push({
      metadata: {
        Icon: RevertIcon,
        iconProps: {
          stroke: theme.sk.color.icon.primary,
        },
        onPress: onTransactionHistoryPress,
      },
      title: i18n.t('transaction_history'),
      value: PaymentsAction.TRANSACTION_HISTORY,
    });
  }

  if (onPaymentLinksPress) {
    moreActionsList.push({
      metadata: {
        Icon: ChainLinkIcon,
        iconProps: {
          fill: theme.sk.color.icon.primary,
        },
        onPress: onPaymentLinksPress,
      },
      title: i18n.t('payment_links'),
      value: PaymentsAction.PAYMENT_LINKS,
    });
  }

  if (onBankDepositsPress) {
    moreActionsList.push({
      metadata: {
        Icon: BankIcon,
        iconProps: {
          stroke: theme.sk.color.icon.primary,
        },
        onPress: onBankDepositsPress,
      },
      title: i18n.t('bank_deposits.title'),
      value: PaymentsAction.BANK_DEPOSITS,
    });
  }

  return moreActionsList;
};
